import styled from '@emotion/styled';
import { SPACER } from 'radiance-ui/lib/constants';

import { LOCAL_COLORS } from 'styles/constants';

export const GlyphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  padding-bottom: ${SPACER.large};
  flex: 1;
`;

export const ImageContainer = styled.div`
  width: 48px;
`;

export const NameContainer = styled.div<{ textColor?: string }>`
  padding-top: ${SPACER.small};
  font-size: ${SPACER.medium};
  line-height: 130%;
  color: ${({ textColor }) => textColor ?? LOCAL_COLORS.textInverse};
  text-align: center;
`;
